import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCrnWo2y1p_DRlx7sVKi8xhoyCtR6lmdCw",
  authDomain: "maw-financas.firebaseapp.com",
  projectId: "maw-financas",
  storageBucket: "maw-financas.firebasestorage.app",
  messagingSenderId: "35725912486",
  appId: "1:35725912486:web:6ac27d45619b02d2150767"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
